module.exports = __webpack_public_path__ + "static/media/anni_border.9c2b8108.png";